<template>
  <GenericStep v-bind="$attrs">
    <div
      v-for="language of peParty.learned_languages"
      :key="language.id"
      class="mb-12"
    >
      <LanguagesCard
        :item="language"
      />
    </div>

    <SectionAdderLine
      section="Language"
      :has-new-section="peLanguagesCardHasNewSection"
      @on-add="peLanguagesCardAddSection"
    />
  </GenericStep>
</template>

<script>
import { cloneDeep, isEqual } from 'lodash'
import { mapActions, mapGetters } from 'vuex'

import { PARTY_NAMESPACE } from '@/store/party'

import GenericStep from '@/components/Party/QuickInterview/GenericStep.vue'
import LanguagesCard from '@/components/Party/PartyEdit/SectionCards/BackgroundCards/LanguagesCard.vue'
import SectionAdderLine from '@/components/Party/PartyEdit/SectionTools/SectionAdderLine.vue'

export default {
  name: 'LanguagesStep',

  components: {
    GenericStep,
    LanguagesCard,
    SectionAdderLine,
  },

  inheritAttrs: false,

  data () {
    return {
      hasChanged: false,
      originalData: null,
    }
  },

  computed: {
    relevantFields () {
      return this.peParty.learned_languages
    },

    ...mapGetters(PARTY_NAMESPACE, [
      'peLanguagesCardHasNewSection',
      'peParty',
    ]),
  },

  watch: {
    relevantFields (value) {
      if (!this.hasChanged && !isEqual(value, this.originalData)) {
        this.hasChanged = true
        this.$emit('changed', true)
      }
    },
  },

  created () {
    this.originalData = cloneDeep(this.relevantFields)
  },

  methods: {
    ...mapActions(PARTY_NAMESPACE, [
      'peLanguagesCardAddSection',
    ]),
  },
}
</script>
